<template>
    <div class="px-4 py-2 max-h-64 overflow-auto border-b border-slate-200">
        <details>
            <summary class="text-xs font-medium text-slate-600 cursor-pointer">Recorded account evidence</summary>
            <p v-if="pending" class="text-xs text-slate-500 py-2">Loading recorded evidence…</p>
            <p v-else-if="error" class="text-xs text-red-600 py-2">Account evidence could not be loaded. Its source and qualification have not been verified.</p>
            <CampaignEditChatAccountEvidence v-else-if="data" :evidence="data" class="mt-2" />
        </details>
    </div>
</template>
<script setup lang="ts">
const props = defineProps<{ campaignId: number; assignmentId: number }>();
const { data, pending, error } = useFetch(() => `/api/icps/${props.campaignId}/account-evidence`, {
    method: 'POST', body: computed(() => ({ assignmentId: props.assignmentId })),
});
</script>
